export default __webpack_public_path__ + "static/media/PaintCan_Preview_Transparent.c55baee8.png";